













import {IGrabSchedule} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {Component, Mixins, Prop} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class GrabbingSchedule extends Mixins(LocalData, Http) {
    @Prop() readonly value!: IGrabSchedule;
    @Prop({default: false}) readonly allDaysSelected!: boolean;

    mounted() {
        if (this.value != null && this.allDaysSelected) {
            this.value.monday = true
            this.value.tuesday = true
            this.value.wednesday = true
            this.value.thursday = true
            this.value.friday = true
            this.value.saturday = true
            this.value.sunday = true
        }
    }
}
